import { render, staticRenderFns } from "./WxPayDialog.vue?vue&type=template&id=157e7bc6&scoped=true&"
import script from "./WxPayDialog.vue?vue&type=script&lang=js&"
export * from "./WxPayDialog.vue?vue&type=script&lang=js&"
import style0 from "./WxPayDialog.vue?vue&type=style&index=0&id=157e7bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e7bc6",
  null
  
)

export default component.exports